import {
    UserServicesGetSTREMAConfigurations,
    UserServicesGetErpSilentLoginURL,
} from "@services/UserServices";
import { GetIndicatorsByUser } from "@services/b2b/my-garage/MyGarageServices";

export default {
    components: {
        VehicleSearchComponent: () =>
            import(
                "@components/shared/widgets/vehicle-identification/VehicleSearchComponent"
            ),
    },
    data() {
        return {
            modal: {
                show: false,
                item: null,
            },
        };
    },
    computed: {
        computedVehicle() {
            return this.$store.getters["vehicleIdentification/getState"]
                .processNumber;
        },
        availableModules() {
            let modules = this.$store.getters["auth/getState"].modules;

            let visibleModules = modules.filter((o) => o.isVisible);

            // Temporary remove modules
            visibleModules = visibleModules.filter(
                (e) =>
                    e.moduleId !==
                        this.$globals.MODULES.SUPPLIER_MANAGEMENT.ID &&
                    e.moduleId !== this.$globals.MODULES.CATALOGS.ID &&
                    e.moduleId !== this.$globals.MODULES.PARTS_INFORMATION.ID &&
                    e.moduleId !== this.$globals.MODULES.CHAT.ID &&
                    e.moduleId !== this.$globals.MODULES.MY_GARAGE.ID
            );

            if (visibleModules.length > 1) {
                visibleModules = visibleModules.filter(
                    (e) =>
                        e.moduleId !==
                        this.$globals.MODULES.VEHICLE_IDENTIFICATION.ID
                );
            }

            return visibleModules;
        },
    },
    watch: {
        computedVehicle: {
            handler: function (newValue, oldValue) {
                if (newValue && this.modal.item) {
                    this.clickMenuItem(this.modal.item);
                }
                if (!newValue && this.routeRequiresVehicleLoaded()) {
                    this.modal.show = true;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        getPathBeforeSecondSlash(inputString) {
            const firstSlashIndex = inputString.indexOf("/");
            if (firstSlashIndex === -1) {
                return inputString;
            }
            const secondSlashIndex = inputString.indexOf(
                "/",
                firstSlashIndex + 1
            );
            if (secondSlashIndex === -1) {
                return inputString;
            }
            return inputString.slice(0, secondSlashIndex);
        },
        isInboxSubmenuActive(item) {
            return (
                item.moduleId === this.$globals.MODULES.REQUEST_MANAGER.ID &&
                this.$route.path.startsWith("/request-manager/inbox")
            );
        },
        menuClass(item) {
            const isCurrentModule =
                this.getPathBeforeSecondSlash(this.$route.path).includes(
                    item.route
                ) && !this.isInboxSubmenuActive(item);

            return `${!item.isActive ? "disabled-a" : ""} ${
                isCurrentModule
                    ? "router-link-exact-active router-link-active"
                    : ""
            }`;
        },
        modalClosed() {
            this.modal.show = false;
        },
        clickMenuItem(item) {
            this.modal.item = null;
            if (item.isActive) {
                if (
                    this.moduleRequiresVehicleLoaded(item.moduleId) &&
                    !this.computedVehicle
                ) {
                    this.modal.item = item;
                    this.modal.show = true;
                } else if (
                    item.moduleId === this.$globals.MODULES.DATAREPAIR.ID
                ) {
                    this.openDatarepair();
                } else if (item.moduleId === this.$globals.MODULES.WEBSHOP.ID) {
                    this.openWebshop();
                } else if (item.moduleId === this.$globals.MODULES.AUTOCOM.ID) {
                    this.openAutocom(item.url);
                } else if (item.moduleId === this.$globals.MODULES.ERP.ID) {
                    this.openErp();
                } else if (item.url) {
                    if (
                        this.$analytics &&
                        item.moduleId === this.$globals.MODULES.DSB.ID
                    ) {
                        this.$analytics.dsbLinkClicked();
                    }
                    window.open(item.url);
                } else if (item.route) {
                    this.$router.push(item.route);
                }
            }
        },
        moduleRequiresVehicleLoaded(moduleId) {
            return (
                moduleId === this.$globals.MODULES.AUTOCOM.ID ||
                moduleId === this.$globals.MODULES.TECHNICAL_INFORMATION.ID ||
                moduleId === this.$globals.MODULES.MARKETING.ID
            );
        },
        routeRequiresVehicleLoaded() {
            return (
                window.location.href.includes("active-reception/") ||
                window.location.href.includes("tech-info")
            );
        },
        openDatarepair() {
            UserServicesGetSTREMAConfigurations(
                this.$store.getters["auth/getState"].entityParent
            )
                .then((response) => {
                    this.$store.commit("menuLinks/setDatarepairState", {
                        show: true,
                        mobilePhone: response.data.result.mobilePhone || "",
                    });
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error(
                        "error fetching strema configs value",
                        error
                    );
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        openWebshop() {
            this.$store.commit("menuLinks/setWebshopState", true);
            if (this.$analytics) {
                this.$analytics.webshopLinkClicked();
            }
        },
        openAutocom(url) {
            let vin = this.$helpers.getVehicleAttribute(
                this.$globals.ATTRIB_ID.VIN
            );
            if (vin) {
                window.open(`${url}VIN=${vin.value}`);
            } else {
                let kType = this.$helpers.getVehicleAttribute(
                    this.$globals.ATTRIB_ID.VEHICLE_ID
                );
                if (kType) {
                    window.open(`${url}TecDoc=${kType.value}`);
                }
            }
        },
        async openErp() {
            await UserServicesGetErpSilentLoginURL().then((response) => {
                window.open(response.data.result);
            });
        },
        getGarageIndicators() {
            let modules = this.$store.getters["auth/getState"].modules;
            let existsMyGarage = modules.find(
                (o) => o.moduleId == this.$globals.MODULES.MY_GARAGE.ID
            );
            if (existsMyGarage) {
                this.$store.commit("loadings/setStateLoadingTemplate", true);
                return GetIndicatorsByUser()
                    .then((response) => {
                        this.$store.commit("dashboard/setMetrics", {
                            metricsInformation: response.data.result,
                            hasViewGraphic: !!response.data.result,
                        });
                    })
                    .catch((error) => {
                        this.$requestStatus.checkRequestStatus(
                            error.response.status,
                            this.$route.name
                        );
                        console.error("error to get dropdowns values", error);
                    })
                    .finally(() => {
                        this.$store.commit(
                            "loadings/setStateLoadingTemplate",
                            false
                        );
                    });
            }
        },
    },
};
